interface ProductTitleData {
    name?: string;
    slug?: string;
    brand_name?: string;
    tire_size?: string;
    original_name?: string;
    source_file?: string;
    scraping_date?: string;
    production_year?: string | number;
    properties?: {
        pattern?: string;
        season?: string;
        load_index?: string | number;
        speed_index?: string;
        tire_construction?: string;
    };
}

export function getProductProductionYear(product: ProductTitleData) {
    if (product.production_year) return product.production_year;
    if (product.source_file !== 'agir_vasita_pdf') return '';

    const importYear = product.scraping_date?.match(/^\d{4}/)?.[0];
    return importYear || String(new Date().getFullYear());
}

export function getProductSeason(product: ProductTitleData) {
    if (product.properties?.season) return product.properties.season;

    const sourceDetails = `${product.properties?.tire_construction || ''} ${product.original_name || ''}`;
    const normalizedDetails = sourceDetails
        .toLocaleUpperCase('tr-TR')
        .replace(/İ/g, 'I')
        .replace(/Ş/g, 'S')
        .replace(/Ğ/g, 'G')
        .replace(/Ü/g, 'U')
        .replace(/Ö/g, 'O')
        .replace(/Ç/g, 'C');
    if (/\b(?:4\s*MEVSIM|DORT\s*MEVSIM)\b/.test(normalizedDetails)) return '4 Mevsim';
    if (/\b(?:KIS|WINTER)\b/.test(normalizedDetails)) return 'Kış';
    if (/\b(?:YAZ|SUMMER)\b/.test(normalizedDetails)) return 'Yaz';
    if (/M\+S|3PMSF/i.test(sourceDetails)) return '4 Mevsim';
    return '';
}

export function getProductPattern(product: ProductTitleData) {
    if (product.properties?.pattern) return product.properties.pattern;
    if (!product.tire_size) return '';

    return product.name?.replace(product.tire_size, '').replace(product.brand_name || '', '').trim() || '';
}

function formatPattern(pattern: string) {
    return pattern
        .replace(/\bRC[-\s]?700\b/i, 'RC700')
        .split(/\s+/)
        .map(part => /\d/.test(part) || part.length <= 2
            ? part.toUpperCase()
            : `${part.charAt(0).toUpperCase()}${part.slice(1).toLowerCase()}`)
        .join(' ');
}

export function getProductDisplayName(product: ProductTitleData) {
    if (product.source_file === 'agir_vasita_pdf' && product.name) return product.name;

    const properties = product.properties;
    const isHeavyVehiclePdf = product.source_file === 'agir_vasita_pdf'
        || Boolean(properties?.pattern)
        || Boolean(properties?.tire_construction && product.original_name);

    if (!isHeavyVehiclePdf || !product.tire_size) return product.name || '';

    const pattern = getProductPattern(product);
    if (!pattern) return product.name || '';

    const season = getProductSeason(product);
    const loadSpeedIndex = `${properties?.load_index || ''}${properties?.speed_index || ''}`;

    return [
        product.brand_name,
        formatPattern(pattern),
        product.tire_size,
        loadSpeedIndex,
        season,
        'Lastik'
    ].filter(Boolean).join(' ');
}
